var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner-overlay"},[_c('div',{staticClass:"spinner-overlay"})])
}]

export { render, staticRenderFns }